import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getPaymentInfo, resetPaymentInfo } from '../../../actions/Task';
import { withRouter } from 'react-router';
import ReactToPrint from 'react-to-print';
import Template from '../../../components/Template/AfterLoginTemplate';
import InvoicePdfContent from '../../../components/Parts/InvoicePdfContent';
import Moment from 'moment';
import Invoice from '../../../assets/images/Invoice.png';
import { Link } from 'react-router-dom';
import * as RT from '../../../constants/Routing';

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
    this.userData = this.props.Task.participantDetail;
    this.taskData = this.props.Task.taskDetail;
    this.state = {
      selectedDate: this.props.match.params.year + '/' + this.props.match.params.month, // 2019/04から今月までの範囲（実施月）
      dueDate: this.props.match.params.dueDate,
      invoiceId: this.props.match.params.invoiceId
    };
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
  }

  //  eslint-disable-next-line react/no-deprecated
  componentWillMount = () => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    this.props.getPaymentInfo(token, enterpriseId, this.state.selectedDate);
  };

  componentWillUnmount = () => {
    this.props.resetPaymentInfo();
  };

  goBack = () => {
    // console.log(this.props);
    this.props.history.goBack();
  };

  _renderLeftpart2 = () => {
    const dateFrom = Moment(this.state.dueDate, 'YYYY-MM-DD');
    let yearEnd = dateFrom.year();
    let monthEnd = dateFrom.month() + 1;
    let dayEnd = dateFrom.date();
    const { totalRewal } = this.props.Task.paymentInfo;
    var rewal = totalRewal.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    return (
      <table className="table pdf-table">
        <thead>
          <tr>
            <th>ご請求金額</th>
            <th>¥{rewal}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="pdf-table-td1">件名　：</td>
            <td>taskellご利用料</td>
          </tr>
          <tr>
            <td className="pdf-table-td1">支払条件　：</td>
            <td>口座振込</td>
          </tr>
          <tr>
            <td className="pdf-table-td1">お支払期限　：</td>
            <td>
              {yearEnd}年 {monthEnd}月 {dayEnd}日
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  _renderPaymentItems = () => {
    const items = this.props.Task.paymentInfo.Items;
    const { feeRate, consumptionTax } = this.props.Task;
    const strRate = feeRate != undefined ? feeRate.replace('%', '') : '0';
    const strTax = feeRate != undefined ? consumptionTax.replace('%', '') : '0';

    if (items !== null && items.constructor === Array && items.length > 0) {
      const sortedItems = items.sort((a, b) => b.startDate - a.startDate);

      return sortedItems.map(item => {
        var a = Number(item.amount) * (Number.parseInt(strRate) / 100);
        var b = a * (Number.parseInt(strTax) / 100);
        console.log('TCL: _renderPaymentItems -> Number.parseInt(strRate)', a, b);
        return (
          <tr>
            <td className="td-Id">{item.taskId}</td>
            <td className="td-Title">{item.title}</td>
            <td className="td-Date">{item.startDate + ' ' + item.workTime}</td>
            <td className="td-amount">
              ￥{String(item.amount).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}
            </td>
            <td className="td-worker">1</td>
            <td className="td-subtotal">
              ￥{String(item.amount).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}
            </td>
          </tr>
        );
      });
    }
    return (
      <tr>
        <td colSpan="6">請求対象となる実施済みのタスクがありません。</td>
      </tr>
    );
  };

  _calculateTotalAmount = strData => {
    const items = this.props.Task.paymentInfo.Items;
    const { feeRate, consumptionTax } = this.props.Task;
    const strRate = feeRate != undefined ? feeRate.replace('%', '') : '0';
    const strTax = consumptionTax != undefined ? consumptionTax.replace('%', '') : '0';
    var newTotal = 0;
    if (items !== null && items.constructor === Array && items.length > 0) {
      items.map(item => {
        newTotal = newTotal + parseInt(item.amount);
      });
      const feeRateAmount = newTotal * (strRate / 100);
      const taxAmount = feeRateAmount * (Number.parseInt(strTax) / 100);
      if (strData == 'total') {
        return newTotal.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      } else if (strData == 'feeRate') {
        return feeRateAmount.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      } else {
        return taxAmount.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      }
    }
  };

  _renderPart4 = () => {
    return (
      <table className="table pdf-invoice-table">
        <thead>
          <tr>
            <th>Taskell タスクID</th>
            <th>タスク名</th>
            <th>実地日</th>
            <th />
            <th />
            <th>小計{this._calculateTotalAmount('total')}</th>
          </tr>
        </thead>
        <tbody>{this._renderPaymentItems()}</tbody>
      </table>
    );
  };

  render = () => {
    const { totalRewal } = this.props.Task.paymentInfo;
    const { feeRate, consumptionTax } = this.props.Task;
    const strRate = feeRate != undefined ? feeRate.replace('%', '') : '0';
    const strTax = consumptionTax != undefined ? consumptionTax.replace('%', '') : '0';
    var rewal = totalRewal.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    var day = today.getDay();
    return (
      <Template>
        <div className="invoice_layout">
          <div className="display_none">
            <InvoicePdfContent
              ref={el => (this.componentRef = el)}
              dueDate={this.state.dueDate}
              invoice={this.props.Task.paymentInfo}
              invoiceId={this.state.invoiceId}
              consumptionTaxAmnt={this._calculateTotalAmount('consumptionTax')}
              feeRateAmnt={this._calculateTotalAmount('feeRate')}
              feeRate={strRate}
              consumptionTax={strTax}
              total={this._calculateTotalAmount('total')}
              enterpriseName={this.currentUser.enterpriseName}
            />
          </div>
          <div className="invoice">
            <div className="row">
              <div className="part0">
                <img src={Invoice} />
              </div>
              <div className="issue-billing">
                <div className="issue-billing-inner">
                  <div className="issue-billing-common">
                    <div className="part0_3">発行日:</div>
                    <div className="part0_3_1">
                      {year}年{month}月{day}日
                    </div>
                  </div>
                  <div className="issue-billing-common">
                    <div className="part0_3">請求ID:</div>
                    <div className="part0_3_1">{this.state.invoiceId}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="part1">
              <div className="invoice_title">{this.currentUser.enterpriseName} 御中</div>
            </div>
            <div className="row">
              <div className="amount-address">
                <div className="amount-address-left">{this._renderLeftpart2()}</div>
                <div className="amount-address-right">
                  <div>株式会社シオン</div>
                  <div>〒105-0014</div>
                  <div>東京都港区芝2-3-9</div>
                  <div>VORT芝公園Ⅱ 2階</div>
                </div>
              </div>
              <div className="part3">下記の通りご請求申し上げます。</div>
              <div className="part4">{this._renderPart4()}</div>
              <div className="part5">
                {/* <div className="part5_2">中計 {this._calculateTotalAmount("total")}</div> */}
                <div className="part5_1" />
                <table className="table pdf-invoice-table">
                  <tbody>
                    <tr>
                      <td className="td-Id" />
                      <td className="td-Date" />
                      <td className="td-amount" />
                      <td className="td-worker">ご利用手数料 {strRate}%</td>
                      <td className="td-subtotal">{this._calculateTotalAmount('feeRate')}</td>
                    </tr>
                    <tr>
                      <td className="td-Id" />
                      <td className="td-Date" />
                      <td className="td-amount" />
                      <td className="td-worker">消費税 {strTax}%</td>
                      <td className="td-subtotal">
                        {this._calculateTotalAmount('consumptionTax')}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="part5 tax-consumption">
                <table className="table pdf-invoice-table">
                  <tbody>
                    <tr>
                      <td className="td-Id" />
                      <td className="td-Date" />
                      <td className="td-amount" />
                      <td className="td-worker">合計 (消費税込み)</td>
                      <td className="td-subtotal">¥{rewal}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="part7">
                <div className="part7_1 row">
                  <div className="part7_2">お振込先</div>
                </div>
                <div className="part7_1 row">
                  <div className="part7_2">金融機関名 ：</div>
                  <div className="part7_3">三井住友銀行</div>
                </div>
                <div className="part7_1 row">
                  <div className="part7_2">支店名 ：</div>
                  <div className="part7_3">神田支店 (219)</div>
                </div>
                <div className="part7_1 row">
                  <div className="part7_2">口座種別 ：</div>
                  <div className="part7_3">普通</div>
                </div>
                <div className="part7_1 row">
                  <div className="part7_2">口座番号 ：</div>
                  <div className="part7_3">3380198</div>
                </div>
                <div className="part7_1 row">
                  <div className="part7_2">口座名義 ：</div>
                  <div className="part7_3">カ) シオン</div>
                </div>
                <div className="part7_1 row">
                  *恐れ入りまずが振り込み手数料は貴社にてご負担ください。
                </div>
              </div>
            </div>
            <div className="row part8">
              <div className="col-4" />
              <div className="col-4 center">
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{
                    marginBottom: '10mm',
                    marginRight: '20mm'
                  }}
                >
                  <ReactToPrint
                    trigger={() => <a href="#">請求書を出力する</a>}
                    content={() => this.componentRef}
                  />
                </button>
              </div>
              <div className="col-4 center">
                <button
                  type="button"
                  onClick={this.goBack}
                  className="btn btn-primary"
                  style={{
                    marginBottom: '10mm',
                    marginRight: '20mm'
                  }}
                >
                  戻る
                </button>
              </div>
            </div>
          </div>
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch =>
  bindActionCreators({ getPaymentInfo, resetPaymentInfo }, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);

// ReactDOM.render(<App />, document.getElementById("root"));
